export default {"src":"/_next/static/media/bathroom.212e44ac.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};